import React from 'react';
import { Menu,ChevronRight } from 'lucide-react';
import './styles.css';

interface MenuToggleProps {
  isOpen: boolean;
  onClick: () => void;
}

const MenuToggle: React.FC<MenuToggleProps> = ({ isOpen, onClick }) => {
  return (
    <button 
      className="menu-toggle"
      onClick={onClick}
      aria-label={isOpen ? 'Collapse sidebar' : 'Expand sidebar'}
    >
      {isOpen ? (
        <ChevronRight size={24} strokeWidth={2} />
      ) : (
        <Menu size={24} strokeWidth={2} />
      )}
    </button>
  );
};

export default MenuToggle; 